import type {ComponentExportStructure} from '@wix/document-services-types'
import type {SingleComponentPluginFunction} from '../../types'
import {convertConnectionToCodeName} from './constants'

export const pack: SingleComponentPluginFunction = (component: ComponentExportStructure): void => {
    convertConnectionToCodeName(component)
}
